export const diretoriaHtml = `
<div
                        style="
                          width: 100%;
                          flex-grow: 1;
                         height: 100%;
                          border-radius: 12px;
                          background: linear-gradient(333deg, #B15FF8, #EFD6FF);
                          box-shadow: none;
                        "
                      >
                        <div
                          style="
                            display: flex;
                            height: 100%;
                            flex-direction: row;
                            justify-content: space-between;
                            align-items: start;
                            padding: 16px;
                          "
                        >
                          <div
                            style="
                              height: 100%;
                              display: flex;
                              flex-direction: column;
                              align-items: flex-start;
                              justify-content: center;
                              gap:4px
                            "
                          >
                            <img
                              src="https://drive.google.com/thumbnail?id=1lRDpgCy4eWpbXBCN4nm0LdoHRBStkv_q"
                              width="60"
                              height="60"
                              alt="Icon"
                            >
                            <span
                              style="
                                padding-left: 8px;
                                font-size: 16px;
                                font-weight: 700;
                                color: #5027A1;
                              "
                            >
                              Título do card 
                            </span>
                            <div
                              style="padding-left: 8px; font-size: 24px; color: #5027A1"
                            >
                              {chave}
                            </div>
                          </div>
                        </div>
                      </div>
`;

export const clientesEContratosHtml = `<div style="width: 100%; position: relative; z-index: 0; flex-grow: 1; height: 100%; border-radius: 12px;  background-color: {color}; padding: 8px;">
  <div style="display: flex; height: 100%; flex-direction: row; justify-content: space-between; align-items: flex-start;">
    
    <div style="height: 100%; display: flex; flex-direction: column; gap: 8px; align-items: flex-start; justify-content: flex-start; text-overflow: ellipsis; overflow: hidden; max-width: calc(100% - 60px); white-space: nowrap;">
      
      <div style="display: flex; flex-direction: row; gap: 4px;">
        <span style="font-size: 34px; font-weight: 700; color: {textPrimary};">{chave}</span>
      </div>

      <span style="font-size: 16px; font-weight: 700; color: {textSecondary};">Título do card</span>

      <div style="display: flex; gap: 4px; align-items: center;">
        <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24" fill="#4CAF50">
          <path d="M0 0h24v24H0z" fill="none"/>
          <path d="M7 14l5-5 5 5H7z"/>
        </svg>
        <span style="font-size: 14px; font-weight: 600; color: #4CAF50;">{chave}</span>
      </div>
    </div>

    <div style="position: relative; width: 80px; height: 80px; margin-bottom: 8px;">
      <div style="background-color: rgba(76, 175, 80, 0.3); padding: 8px; border-radius: 50%; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
          <img src="https://drive.google.com/thumbnail?id=163d-SdWpBk4fCkEFG5uChbViUygKJ1mj" height="60px" width="60px">
      </div>
    </div>

  </div>
</div>`;

export const ocorrenciasHtml = `
  <div style="position: relative; display: flex; justify-content: space-between; align-items: center; height: 100%; width: 100%; border-radius: 12px; background-color: {color}; padding: 24px; overflow: hidden; box-sizing: border-box;">

  <div style="display: flex; flex-direction: column;">
    <span style="font-size: 24px; font-weight: 600; color: {textPrimary};">{chave}</span>
    <span style="font-size: 20px; font-weight: 500; color: {textSecondary};">Título do card</span>
  </div>

  <div style="
    background-color: rgba(255, 193, 7, 0.1);
    height: 100%;
    width: 150px;
    transform: rotate(46deg);
    position: absolute;
    right: -80px;
    border-radius: 7px;
    z-index: 0;
  "></div>

  <img
    src="https://drive.google.com/thumbnail?id=1yGgIdxAVTRYKfVWG027Sa1V1fSD7y4Rc"
    alt="Gráfico"
    height="45px"
    width="45px"
    style="position: absolute; right: 10px; z-index: 1;"
  />
</div>
`;
